export default {
  nonReportingDevices: 1,
  batteryStatus: 2,
  lowRefill: 3,
  summary: 4,
  badgeBatteryStatus: 5
};
